export const SET_SESSION = 'SET_SESSION';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_USER_INFOS = 'SET_USER_INFOS';
export const SET_USAGE_DATAS = 'SET_USAGE_DATAS';



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js